import React, { Component } from 'react';
import { Widget } from '@typeform/embed-react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import EmployerReferralModal from '../EmployerReferralModal';
import './NPSModal.scss';

const TYPEFORM_HEIGHT = '450px';
const TYPEFORM_WIDTH = '600px';

class NPSModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showNPSModal: props.showNPSInitial,
      showReferralModal: !props.showNPSInitial,
    };

    this.closeModalAndCleanURLParams = this.closeModalAndCleanURLParams.bind(this);
    this.showReferralModal = this.showReferralModal.bind(this);
  }

  closeModalAndCleanURLParams() {
    window.location.href = window.location.pathname;
    this.setState({ showNPSModal: false, showReferralModal: false });
  }

  showReferralModal() {
    this.setState({ showNPSModal: false, showReferralModal: true });
  }

  renderTypeform() {
    const { NPSFormId, utmParams } = this.props;

    if (NPSFormId) {
      return (
        <div className="typeform-container">
          <Widget
            id={NPSFormId}
            hidden={utmParams}
            style={{ height: TYPEFORM_HEIGHT, width: TYPEFORM_WIDTH }}
            onSubmit={() => this.showReferralModal()}
          />
        </div>
      );
    }

    return null;
  }

  renderNPSModal() {
    const { showNPSModal } = this.state;

    return (
      <Modal
        dialogClassName="nps-modal"
        show={showNPSModal}
        onHide={() => this.closeModalAndCleanURLParams()}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <div className="nps-modal-title-text">
              We value your insights and partnership.
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="non-typeform-components">
            <div className="nps-modal-body-text">
              Your feedback is important to us and will help Clora continue to improve.
            </div>
            <hr className="line" />
          </div>
          {this.renderTypeform()}
        </Modal.Body>
      </Modal>
    );
  }

  renderReferralModal() {
    const {
      csrfToken,
      referralPath,
      newReferralPath,
      shareOnLinkedinUrl,
      authCodeUrl,
      authStatus,
    } = this.props;

    const { showReferralModal } = this.state;

    const referralHeroCopy = this.props.showNPSInitial
      ? 'Thanks for sharing your feedback!' : 'Congratulations on your new hire!';

    return (
      <EmployerReferralModal
        csrfToken={csrfToken}
        referralPath={referralPath}
        newReferralPath={newReferralPath}
        shareOnLinkedinUrl={shareOnLinkedinUrl}
        authCodeUrl={authCodeUrl}
        authStatus={authStatus}
        showModal={showReferralModal}
        onHideCallback={this.closeModalAndCleanURLParams}
        referralHeroCopy={referralHeroCopy}
      />
    );
  }

  render() {
    return (
      <div>
        {this.renderReferralModal()}
        {this.renderNPSModal()}
      </div>
    );
  }
}

NPSModal.propTypes = {
  utmParams: PropTypes.shape({}),
  NPSFormId: PropTypes.string.isRequired,
  csrfToken: PropTypes.string.isRequired,
  referralPath: PropTypes.string.isRequired,
  newReferralPath: PropTypes.string.isRequired,
  shareOnLinkedinUrl: PropTypes.string.isRequired,
  authCodeUrl: PropTypes.string,
  authStatus: PropTypes.number,
  showNPSInitial: PropTypes.bool,
};

NPSModal.defaultProps = {
  utmParams: { utm_source: 'unknown', utm_medium: 'unknown', utm_campaign: 'unknown' },
  authCodeUrl: null,
  authStatus: null,
  showNPSInitial: false,
};

export default NPSModal;
